import { t } from "i18next";
import { Button } from "@/components/ui/button";
import { ReadOnlyInputEdit } from "./components/ReadOnlyInputEdit";
import { VerifyIdentity2FADialog } from "@/components/ui/VerifyIdentity2FADialog";
import { PasswordChangeDialog } from "./components/PasswordChangeDialog";
import { DeleteAccountDialog } from "./components/DeleteAccountDialog";
import { AccountSettingsField } from "@/common/enums/accountSettings";
import { useAuthStore } from "@/store/auth.store";
import { EmailChangeDialog } from "./components/EmailChangeDialog";
export default function AccountTab(): JSX.Element {
  const { userData } = useAuthStore.getState();

  return (
    <section>
      <div className="space-y-8">
        <VerifyIdentity2FADialog
          name={AccountSettingsField.CHANGE_EMAIL}
          trigger={
            <ReadOnlyInputEdit
              label={t("settings.account.changeEmailLabel")}
              value={userData?.email ?? ""}
            />
          }
        />
        <EmailChangeDialog />
        <VerifyIdentity2FADialog
          name={AccountSettingsField.CHANGE_PASSWORD}
          trigger={
            <ReadOnlyInputEdit
              label={t("settings.account.changePasswordLabel")}
              value="***************"
            />
          }
        />
        <PasswordChangeDialog />
        <VerifyIdentity2FADialog
          name={AccountSettingsField.DELETE_ACCOUNT}
          trigger={
            <Button variant="destructive">
              {t("settings.account.deleteAccount.confirmButton")}
            </Button>
          }
        />
        <DeleteAccountDialog />
      </div>
    </section>
  );
}
